<template>
	<div v-if="inputRecordFormVisible" style="width: 100%">
		<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="供应商：">
				<el-select v-model="formInline.supplyKeyId" placeholder="请选择供应商" clearable size="small">
					<el-option v-for="item in supplyList" :key="item.keyId" :label="item.name" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="入库单号：">
				<el-input clearable v-model="formInline.inputStoreNo" size="small" placeholder="请输入入库单号" @keyup.enter.native="inputChange"></el-input>
			</el-form-item>
			<el-form-item label="入库时间：">
				<el-date-picker
					v-model="inputDateList"
					type="daterange"
					value-format="yyyy-MM-dd"
					range-separator="~"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					format="yyyy-MM-dd"
					clearable
					size="small"
					@change="changeDate"
				/>
			</el-form-item>
			</lcsj-filter>
		<STable :columns="columnsData" :data="listData" :loading="loading" border @get-data="getListData">
			<template #price>
				<el-table-column v-if="canSeeCost" label="单价" min-width="100" align="center">
					<template #default="scope">
						<span style="color: #ff9900; font-weight: 600; white-space: nowrap" v-money="scope.row.price || 0">￥{{ Number(scope.row.price || 0).toFixed(2) }} 元</span>
					</template>
				</el-table-column>
			</template>
			<template #money>
				<el-table-column v-if="canSeeCost" label="金额" min-width="100" align="center">
					<template #default="scope">
						<span style="color: #ff9900; font-weight: 600; white-space: nowrap" v-money="scope.row.money || 0">￥{{ Number(scope.row.money || 0).toFixed(2) }} 元</span>
					</template>
				</el-table-column>
			</template>
			<template #inputUserKeyId>
				<el-table-column label="金额" width="100" align="center">
					<template #default="scope">
						<span v-if="scope.row.inputUserKeyId">已入库</span>
						<span v-else>未入库</span>
					</template>
				</el-table-column>
			</template>
		</STable>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
	</div>
</template>

<script>
import costPermission from "@/utils/costPermission.js";
import { getSupplyInfoList } from "@/api/baseDataApi.js";
import { GetInputStoreDtlPageList } from "@/api/receiptApi.js";
export default {
	watch: {
		inputRecordFormVisible(visible) {
			if (!visible) return;
			this.getSupplyInfoList();
		}
	},
	mixins: [costPermission],
	data() {
		return {
			inputRecordFormVisible: false,
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				supplyKeyId: "",
				goodsKeyId: "",
				inputStoreNo: "",
				startTime: null,
				endTime: null
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "inputStoreNo",
					label: "入库单号",
					align: "center",
					minWidth: "220"
				},
				{
					slot: "inputUserKeyId",
					label: "是否入库",
					align: "center",
					minWidth: "120"
				},
				{
					prop: "inputUserName",
					label: "入库人",
					align: "center",
					minWidth: "120"
				},
				{
					prop: "inputDate",
					label: "入库时间",
					align: "center",
					minWidth: "160"
				},
				{
					prop: "supplyName",
					label: "供应商",
					align: "center",
					minWidth: "120"
				},
				{
					prop: "goodsInfo.type",
					label: "商品品牌",
					align: "center",
					isKeep: true,
					minWidth: "120"
				},
				{
					prop: "goodsInfo.name",
					label: "商品名称",
					align: "center",
					minWidth: "160"
				},
				{
					prop: "goodsInfo.qiuJing",
					label: "球镜",
					minWidth: "80",
					align: "center"
				},
				{
					prop: "goodsInfo.zhuJing",
					label: "柱镜",
					align: "center",
					minWidth: "80",
					align: "center"
				},
				{
					slot: "price",
					label: "单价",
					align: "center",
					minWidth: "80",
					align: "center"
				},
				{
					prop: "quantity",
					label: "数量",
					align: "center",
					minWidth: "80",
					align: "center"
				},
				{
					slot: "money",
					label: "金额",
					align: "center",
					minWidth: "80",
					align: "center"
				},
				{
					prop: "creator",
					label: "创建人",
					align: "center",
					minWidth: "80"
				},
				{
					prop: "createTime",
					label: "创建时间",
					align: "center",
					minWidth: "150"
				},
				{
					prop: "editor",
					label: "维护人",
					align: "center",
					minWidth: "80"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					align: "center",
					minWidth: "150"
				}
			],

			inputDateList: [],
			supplyList: []
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));

	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 显示弹窗
		showInputRecordDialog(keyId) {
			this.inputRecordFormVisible = true;
			this.formInline.goodsKeyId = keyId;
			this.search();
		},
		// 关闭弹窗
		closeInputRecordDialog() {
			this.inputRecordFormVisible = false;
		},
		// 获取供应商
		getSupplyInfoList() {
			const paramer = {};
			getSupplyInfoList(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.supplyList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取供应商信息失败!");
				});
		},
		changePages() {},
		// 获取列表
		getListData() {
			this.loading = true;
			GetInputStoreDtlPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 时间选择
		changeDate(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
		}
	}
};
</script>

<style scoped></style>
